import { useState } from 'react';
import type { AppCategory } from '../types';

interface SearchFiltersProps {
  onSearch: (keyword: string) => void;
  onCategoryChange: (categoryId: string) => void;
  categories: AppCategory[];
}

export default function SearchFilters({ onSearch, onCategoryChange, categories }: SearchFiltersProps) {
  const [keyword, setKeyword] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleSearch = () => {
    onSearch(keyword);
  };

  const handleCategoryChange = (categoryId: string) => {
    setSelectedCategory(categoryId);
    onCategoryChange(categoryId);
  };

  const handleReset = () => {
    setKeyword('');
    setSelectedCategory('');
    onSearch('');
    onCategoryChange('');
  };

  return (
    <div className="bg-white rounded-lg p-6 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">应用名称</label>
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="支持模糊搜索"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
            onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">应用分类</label>
          <select
            value={selectedCategory}
            onChange={(e) => handleCategoryChange(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
          >
            <option value="">全部分类</option>
            {categories.map((category) => (
              <optgroup key={category.id} label={category.name}>
                {category.children?.map((subCategory) => (
                  <option key={subCategory.id} value={subCategory.id}>
                    {subCategory.name}
                  </option>
                ))}
              </optgroup>
            ))}
          </select>
        </div>
      </div>

      <div className="flex gap-3">
        <button
          onClick={handleSearch}
          className="px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap"
        >
          <i className="ri-search-line mr-2"></i>
          搜索
        </button>
        <button
          onClick={handleReset}
          className="px-6 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm font-medium whitespace-nowrap"
        >
          <i className="ri-refresh-line mr-2"></i>
          重置
        </button>
      </div>
    </div>
  );
}
